"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortMenuAssets = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var SelectAllCheckbox_1 = __importDefault(require("./SelectAllCheckbox"));
var Checkbox_1 = require("./Checkbox");
var SortBySelector_1 = __importStar(require("Dashboard/SortBySelector/SortBySelector"));
var FilterSelector_1 = __importDefault(require("Dashboard/FilterSelector/FilterSelector"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ProjectTypes_1 = require("Project/ProjectTypes");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DashboardTypes_2 = require("../DashboardTypes");
var BulkEngagementPopover_1 = require("./BulkEngagementPopover");
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var BASE_CLASS_NAME = "dashboard-action-tray";
var ActionIconDelayInMs = 50;
var ActionIconCount = 5;
exports.sortMenuAssets = [
    {
        type: SortBySelector_1.MenuItem.Relevance,
        text: "Relevance",
        icon: react_1.default.createElement(icons_1.Search, null),
        sortBy: DashboardTypes_2.SortBy.Relevance,
    },
    {
        type: SortBySelector_1.MenuItem.Edited,
        text: "Last Edited",
        icon: react_1.default.createElement(icons_1.Edit, null),
        sortBy: DashboardTypes_2.SortBy.LastEditedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Created,
        text: "Date Created",
        icon: react_1.default.createElement(icons_1.Clock, null),
        sortBy: DashboardTypes_2.SortBy.CreatedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Name,
        text: "Alphabetical",
        icon: react_1.default.createElement(icons_1.Fonts, null),
        sortBy: DashboardTypes_2.SortBy.Name,
    },
    {
        type: SortBySelector_1.MenuItem.LastViewed,
        text: "Last Viewed",
        icon: react_1.default.createElement(icons_1.ViewDate, null),
        sortBy: DashboardTypes_2.SortBy.LastViewedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Views,
        text: "Page Views",
        icon: react_1.default.createElement(icons_1.Page, null),
        sortBy: DashboardTypes_2.SortBy.Views,
    },
];
var ActionTray = (function (_super) {
    __extends(ActionTray, _super);
    function ActionTray(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRightActions = function () {
            if (_this.selectionState === Checkbox_1.CheckboxState.None) {
                return (react_1.default.createElement("div", { key: "right-actions__selectors", className: "".concat(BASE_CLASS_NAME, "__right-inner right-actions__selectors") },
                    react_1.default.createElement(FilterSelector_1.default, { projectListStore: _this.projectListStore, dashboardViewStore: _this.dashboardViewStore, "$state": _this.dashboardController.$state }),
                    react_1.default.createElement(SortBySelector_1.default, { menuAssets: _this.getSortMenuAssets(), selectedMenuItem: _this.getSelectedSortMenuItem(), onSelectMenuItemHandle: _this.onSelectSortMenuItemHandle, onMouseDown: _this.onSortSelectorMouseDown, sortDirection: _this.projectListStore.sortDirection })));
            }
            else if (_this.projectListStore.selectedFolder === DashboardTypes_1.ProjectCollection.Deleted) {
                return (react_1.default.createElement("div", { key: "right-actions__restore", className: "".concat(BASE_CLASS_NAME, "__right-inner right-actions__restore") },
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: _this.restoreProjects }, "Restore")));
            }
            else {
                return _this.renderBulkActions();
            }
        };
        _this.renderBulkActions = function () {
            var isAllSelectionStarred = _this.isAllSelectionStarred();
            var isAllSelectionArchived = _this.isAllSelectionArchived();
            var projectStores = _this.projectListStore.getProjectStoresByIndexes(_this.selectionStore.selected);
            var editableProjects = projectStores.filter(function (project) {
                return _this.dashboardController.canEditProject(project);
            });
            var selectedProjectsAreEditable = editableProjects.length > 0 && editableProjects.length === projectStores.length;
            var incorrectPermissionsMessage = "You do not have edit permissions to some of the pages you selected.";
            var bulkActionsList = [
                {
                    icon: isAllSelectionStarred ? react_1.default.createElement(icons_1.StarFilled, null) : react_1.default.createElement(icons_1.Star, null),
                    onClick: _this.starProjects,
                    tooltipContent: isAllSelectionStarred ? "Unstar" : "Star",
                },
                {
                    icon: react_1.default.createElement(icons_1.Tag, null),
                    onClick: _this.tagProjects,
                    tooltipContent: "Tag",
                },
                {
                    icon: react_1.default.createElement(icons_1.ChangeOwner, null),
                    onClick: _this.changeOwnerForProjects,
                    tooltipContent: "Change owner",
                },
                {
                    icon: isAllSelectionArchived ? react_1.default.createElement(icons_1.Unarchive, null) : react_1.default.createElement(icons_1.Archive, null),
                    onClick: _this.archiveProjects,
                    tooltipContent: isAllSelectionArchived ? "Unarchive" : "Archive",
                },
                {
                    icon: react_1.default.createElement(icons_1.Delete, null),
                    onClick: _this.deleteProjects,
                    tooltipContent: "Delete",
                    isDestructive: true,
                },
            ];
            return (react_1.default.createElement("div", { key: "right-actions__action-icons", className: "".concat(BASE_CLASS_NAME, "__right-inner right-actions__action-icons") },
                react_1.default.createElement(ReactCSSTransitionGroup, { component: react_1.default.Fragment, transitionName: "right-action-icons-transition", transitionLeave: false, transitionEnter: false, transitionAppear: true, transitionAppearTimeout: ActionIconCount * ActionIconDelayInMs + 200 },
                    react_1.default.createElement("div", { style: constructInlineStyleForActionIcon(0) },
                        react_1.default.createElement(BulkEngagementPopover_1.BulkEngagementPopover, { selectedPages: projectStores.map(function (_a) {
                                var _id = _a._id, status = _a.status, isBlueprint = _a.isBlueprint, isTemplate = _a.isTemplate;
                                return { _id: _id, status: status, isBlueprint: isBlueprint, isTemplate: isTemplate };
                            }), isAdmin: _this.props.isAdmin, iconButtonProps: commonIconButtonProps(react_1.default.createElement(icons_1.Engagement, null), selectedProjectsAreEditable, incorrectPermissionsMessage, "Assign engagement algorithm") })),
                    bulkActionsList.map(function (_a, index) {
                        var icon = _a.icon, onClick = _a.onClick, tooltipContent = _a.tooltipContent, isDestructive = _a.isDestructive;
                        return (react_1.default.createElement("div", { key: index, style: constructInlineStyleForActionIcon(index + 1) },
                            react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ onClick: onClick, isDestructive: isDestructive }, commonIconButtonProps(icon, selectedProjectsAreEditable, incorrectPermissionsMessage, tooltipContent)))));
                    }))));
        };
        _this.getSortMenuAssets = function () {
            if (_this.projectListStore.searchTerm) {
                return exports.sortMenuAssets;
            }
            return exports.sortMenuAssets.filter(function (asset) { return asset.type !== SortBySelector_1.MenuItem.Relevance; });
        };
        _this.getSelectedSortMenuItem = function () {
            if (!_this.projectListStore.sortBy || !_this.projectListStore.sortDirection) {
                var defaultSortMenuAsset = _this.getSortMenuAssets()[0];
                _this.projectListStore.setSortBy(defaultSortMenuAsset.sortBy);
                _this.projectListStore.setSortDirection(DashboardTypes_2.SortDirection.Descending);
                return defaultSortMenuAsset.type;
            }
            switch (_this.projectListStore.sortBy) {
                case DashboardTypes_2.SortBy.Relevance:
                    return SortBySelector_1.MenuItem.Relevance;
                case DashboardTypes_2.SortBy.CreatedAt:
                    return SortBySelector_1.MenuItem.Created;
                case DashboardTypes_2.SortBy.LastEditedAt:
                    return SortBySelector_1.MenuItem.Edited;
                case DashboardTypes_2.SortBy.LastViewedAt:
                    return SortBySelector_1.MenuItem.LastViewed;
                case DashboardTypes_2.SortBy.Views:
                    return SortBySelector_1.MenuItem.Views;
                case DashboardTypes_2.SortBy.Name:
                    return SortBySelector_1.MenuItem.Name;
            }
        };
        _this.onSelectSortMenuItemHandle = function (sortBy, sortDirection) {
            _this.dashboardController.trackDashboardSorted(sortBy, sortDirection);
            _this.projectListStore.setSortBy(sortBy);
            _this.projectListStore.setSortDirection(sortDirection);
        };
        _this.onSortSelectorMouseDown = function () {
            _this.dashboardViewStore.closeAllMenus();
        };
        _this.stopPropagation = function (event) { return event.stopPropagation(); };
        _this.restoreProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.restoreProjects(this.selectionStore.selected)];
                    case 1:
                        _a.sent();
                        this.selectionStore.deselectAll();
                        return [2];
                }
            });
        }); };
        _this.starProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.starProjects(this.selectionStore.selected)];
                    case 1:
                        _a.sent();
                        if (this.projectListStore.selectedStatuses.includes(ProjectTypes_1.SpecialProjectTag.Starred)) {
                            this.projectListStore.forceFetchProjects();
                        }
                        return [2];
                }
            });
        }); };
        _this.archiveProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.archiveProjects(this.selectionStore.selected)];
                    case 1:
                        _a.sent();
                        this.selectionStore.deselectAll();
                        return [2];
                }
            });
        }); };
        _this.deleteProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectListStore.deleteProjects(this.selectionStore.selected)];
                    case 1:
                        _a.sent();
                        this.selectionStore.deselectAll();
                        this.projectListStore.forceFetchProjects();
                        return [2];
                }
            });
        }); };
        _this.changeOwnerForProjects = function () {
            if (_this.projectListStore.selectedFolder === DashboardTypes_1.ProjectCollection.Deleted) {
                throw new Error("Can't change owner of deleted projects");
            }
            var projectStores = _this.projectListStore.getProjectStoresByIndexes(_this.selectionStore.selected);
            _this.dashboardController.changeOwnerForProjects(projectStores);
        };
        _this.tagProjects = function () { return __awaiter(_this, void 0, void 0, function () {
            var projectStores;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.projectListStore.selectedFolder === DashboardTypes_1.ProjectCollection.Deleted) {
                            throw new Error("Can't tag deleted projects");
                        }
                        projectStores = this.projectListStore.getProjectStoresByIndexes(this.selectionStore.selected);
                        return [4, this.dashboardController.openTaggerForProjects(projectStores)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.isAllSelectionStarred = function () {
            var projects = _this.selectedProjects;
            return projects.every(function (project) { return project.isStarred; });
        };
        _this.isAllSelectionArchived = function () {
            var projects = _this.selectedProjects;
            return projects.every(function (project) { return project.isArchived; });
        };
        _this.dashboardController = props.dashboardController;
        _this.selectionStore = props.selectionStore;
        _this.projectListStore = props.projectListStore;
        _this.dashboardViewStore = props.dashboardViewStore;
        return _this;
    }
    Object.defineProperty(ActionTray.prototype, "selectionState", {
        get: function () {
            if (this.props.numSelectedProjects === 0) {
                return Checkbox_1.CheckboxState.None;
            }
            else if (this.isAllSelected) {
                return Checkbox_1.CheckboxState.All;
            }
            else {
                return Checkbox_1.CheckboxState.Some;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionTray.prototype, "isAllSelected", {
        get: function () {
            return this.props.numSelectedProjects >= this.projectListStore.displayedProjectCount;
        },
        enumerable: false,
        configurable: true
    });
    ActionTray.prototype.render = function () {
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__left"), onMouseDown: this.stopPropagation },
                react_1.default.createElement(SelectAllCheckbox_1.default, { resourceLabel: "page", selectionStore: this.selectionStore, selectionState: this.selectionState, numSelectedProjects: this.props.numSelectedProjects, dashboardViewStore: this.dashboardViewStore })),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__right center"), onMouseDown: this.stopPropagation },
                react_1.default.createElement(ReactCSSTransitionGroup, { component: react_1.default.Fragment, transitionName: "".concat(BASE_CLASS_NAME, "__right-actions-transition"), transitionEnterTimeout: 250, transitionLeaveTimeout: 200 }, this.renderRightActions()))));
    };
    Object.defineProperty(ActionTray.prototype, "selectedProjects", {
        get: function () {
            return this.projectListStore.getProjectStoresByIndexes(this.selectionStore.selected);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Checkbox_1.CheckboxState !== "undefined" && Checkbox_1.CheckboxState) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ActionTray.prototype, "selectionState", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ActionTray.prototype, "isAllSelected", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ActionTray.prototype, "onSelectSortMenuItemHandle", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ActionTray.prototype, "onSortSelectorMouseDown", void 0);
    ActionTray = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ActionTray);
    return ActionTray;
}(react_1.default.Component));
exports.default = ActionTray;
var constructInlineStyleForActionIcon = function (buttonPosition) {
    var animationDelayInMs = (ActionIconCount + 1 - buttonPosition) * ActionIconDelayInMs;
    return {
        animationDelay: "".concat(animationDelayInMs, "ms"),
    };
};
function commonIconButtonProps(icon, selectedProjectsAreEditable, incorrectPermissionsMessage, tooltipContent) {
    return {
        icon: icon,
        disabled: !selectedProjectsAreEditable,
        disabledReason: incorrectPermissionsMessage,
        tooltip: {
            content: tooltipContent,
            size: !selectedProjectsAreEditable ? kaleidoscope_1.TooltipSize.Large : kaleidoscope_1.TooltipSize.Small,
        },
        buttonState: kaleidoscope_1.ButtonState.Idle,
    };
}
